module.exports = __webpack_public_path__ + "img/roll-677.1973ea4b.png";